import { useSelector } from 'react-redux';
import { selectAuthToken } from 'selectors';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import {
  ProvisionIntegrationPayload,
  ProvisionIntegrationSuccessResponse,
  ProvisionIntegrationErrorResponse,
  provisionIntegrationApi,
} from '../provisionIntegrationApi';
import { useNotification } from 'hooks/useNotification';

export const useProvisionIntegration = () => {
  const token = useSelector(selectAuthToken);
  const { showError } = useNotification();

  const mutation = useMutation<
    AxiosResponse<ProvisionIntegrationSuccessResponse>,
    AxiosResponse<ProvisionIntegrationErrorResponse>,
    ProvisionIntegrationPayload
  >({
    mutationFn: async (params) => {
      if (!token) {
        throw new Error('No auth token available');
      }
      return provisionIntegrationApi({ params, token }) as Promise<
        AxiosResponse<ProvisionIntegrationSuccessResponse>
      >;
    },
    onError: (error) => {
      // ✅ FIX: Replace alert() with toast notification
      showError(`Provision integration failed! ${error.data.message}`);
    },
  });
  return {
    provisionIntegration: mutation.mutate,
    isProvisioningIntegration: mutation.isPending,
    provisionIntegrationError: mutation.error,
    provisionIntegrationData: mutation.data?.data,
  };
};
